import * as React from "react";
import { forwardRef } from "react";
const SvgTelegram = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 24, cy: 24, r: 24, fill: "#29B6F6" }), /* @__PURE__ */ React.createElement("path", { d: "M34.9 13.5L10.5 22.9c-1.6.6-1.6 1.5-.3 1.9l6.2 1.9 14.3-9c.7-.4 1.3-.2.8.3L20.3 29.2l-.4 6.4c.6 0 .8-.3 1.1-.6l2.7-2.6 5.6 4.1c1 .6 1.8.3 2-1l3.6-17c.4-1.6-.6-2.4-2-1.9l.1.4z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgTelegram);
export default ForwardRef;
